import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { UserInterface } from 'context/auth.context';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API,
});

const authLink = setContext((_, { headers }) => {
  let token = localStorage.getItem('restore.user');
  let tenantId;

  if (token) {
    const userJson: UserInterface = JSON.parse(token);
    token = userJson.tokens.id_token;
    tenantId = userJson.user.tenantId;
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      tenant_id: tenantId,
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
